
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteParty } from '../../firebase-services/db-services'
import { getPartiesFetch, selectParties } from '../../Redux/slices/partyState'
import ConfirmDIalouge from '../ConfirmDIalouge'
import PartyCard from './PartyCard'
import {  toast } from 'react-toastify';

export default function ViewParties({setEditHandler}) {
    const dispatch = useDispatch()
    const parties = useSelector(selectParties)
    const [selectDelete,setSelectDelete] = useState(false)
    const deleteHandler = ()=>{
        deleteParty(selectDelete).then(()=>{
            dispatch(getPartiesFetch())
            setSelectDelete(false)
            setEditHandler({docid:false})()
            toast.success("Party Deleted Successfully")
        }).catch((e)=>{
            toast.error("Failed to delete Party")
            console.log(e)
        })
    }
    const closeHandler=()=>{
        setSelectDelete(false)
    }
    useEffect(() => {
        dispatch(getPartiesFetch())
        return () => {

        }
    }, [dispatch])

    return (
        <section className="text-gray-600 body-font">
            {selectDelete&&<ConfirmDIalouge message={`Delete Party`} desc="Are you sure want to delete this Party and it's related info" action='Confirm'  actionHandler={deleteHandler} closeHandler={closeHandler}/>}

            <div className="container px-5 py-24 mx-auto">
                <div className="flex flex-wrap -m-2">
                    {parties.map((party,i)=><PartyCard key={i} {...party} setEditParty={setEditHandler(party)} setSelectDelete={setSelectDelete}/>)}
                </div>
            </div>
        </section>
    )
}
